<template>
<!-- 安全帽日考勤记录 -->
    <div class="box-second">
        <!-- <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>施工管理</el-breadcrumb-item>
                <el-breadcrumb-item>风险场所</el-breadcrumb-item>
            </el-breadcrumb>
        </p> -->
        <div class="main">
            <div class="build-bar">
                <span>姓名：</span>
                <el-input placeholder="请输入人员姓名" v-model="search.personName"></el-input>
                <span style="margin-left:1vw;">序列号：</span>
                <el-input placeholder="请输入gps设备号" v-model="search.sn"></el-input>
                <span style="margin-left:1vw;">时间：</span>
                <el-date-picker v-model="search.date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                <!-- <el-button type="primary" @click="addRow()">添加</el-button> -->
                <!-- <el-button type="success" @click="handleEdit">参数配置</el-button> -->
            </div>
            <div class="main-table">
                <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" type="index" width="100"></el-table-column>
                    <el-table-column label="姓名">
                        <template slot-scope="scope">
                            <span>{{ scope.row.personName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label=" 设备序列号">
                        <template slot-scope="scope">
                        <span>{{ scope.row.sn }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="所属班组">
                        <template slot-scope="scope">
                            <span>{{scope.row.teamsName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.updateDate}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="图片">
                         <template slot-scope="scope">
                            <el-image v-if="scope.row.thumbnailUrl!=''" style="width: 5vh; height: 5vh;cursor: pointer;" :src="http+scope.row.thumbnailUrl" :preview-src-list="scope.row.srcList"></el-image>
                            <img v-else src="../../../assets//image/zanwutupian.png" style="width: 5vh; height: 5vh;cursor: pointer;" />
                         </template>
                    </el-table-column> -->
                    <!-- <el-table-column label="操作" width="400">
                        <template slot-scope="scope">
                            <el-button size="mini" v-if="isMenuExit('pro:elebox:edit')" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-button size="mini" v-if="isMenuExit('pro:elebox:del')" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
                            <el-button size="mini" type="success" @click="history(scope.$index, scope.row)">历史记录</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import base from '../../../untils/base'
export default {
    data(){
        return{
            search:{
                personName:'',
                sn:'',
                date:util.myTime.getCurTime()
            },
            tableDataEnd:[],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            dataText:'数据加载中...',
            // addVis:false,
            // dialogTitle:'',
            labelPosition:'right',
            // addForm:{
            //     id:'',
            //     projectId:'',
            //     workPlace:'',
            //     attendMatters:'',
            //     riseLevel:'',
            //      photoUrl:'',
            //      thumbnailUrl:''
            // },
            // uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
            // uploadHead1: {
            //     accessToken: util.session.get('token')
            // },
            // rules:{
            //     sn: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }]
            // },
            //二维码
            // codeVis:false,
            // codeUrl:'',
            // codeTit:'',
            // level:[{name:"低风险",id:"0"},{name:"中风险",id:"1"},{name:"高风险",id:"2"}],
            // icon:'',//配电箱图
            // http:base.httpCtx,
            // workPlace:''
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        // this.addForm.projectId = this.groupId
        this.getData()
    },
    methods:{
        getData(){
            var that = this
            this.search.projectId = this.groupId
            this.search.pageNum = this.currentPage
            this.search.pageSize = this.pageSize
            myHttp.selectSafetyGpsOne(this.search).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                    }
                    that.tableDataEnd = list
                    that.totalItems = resp.data.data.list.total
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        handleSizeChange(val) {
          this.pageSize = val
          this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`)
          this.currentPage = val
          this.getData()
        },
        // 监控当前页码
        currentChangePage() {
          this.getData()
        },
        //查询
        doFilter(){
            this.currentPage = 1
            this.getData()
        },

        /**
         * 判断是否展示
         */
        isMenuExit(row){
            // var flag = util.common.filterBtnMenu(row)
            // return flag
            return true
        },

        /**
         * 获取历史记录
         */
        history(index,row){
            // this.$router.push({ path: '/riskHistory/'+row.id })
        },
               // 上传图片
        handleIconSuccess(res, file) {
            // this.icon = URL.createObjectURL(file.raw)
            // console.log(res.data)
            // this.addForm.photoUrl = res.data.savePhotoUrls
            // this.addForm.thumbnailUrl =res.data.saveThumbnailUrls
        },

    },
}
</script>

<style scoped>
    .main{
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .main-table{
        width: 100%;
        height: calc( 100% - 11.4vh );
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 7vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }
    .build-bar > .el-button {
        margin-left: 30px;
        /* background-color: #17b2fe;
        border-color: #17b2fe; */
    }
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
    .avatar{
    width: 100%;
}
</style>

<style>
    @import '../../../assets/css/common.css'
</style>